var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"home-fade"}},[_c(_vm.view,{tag:"component",attrs:{"process":_vm.process,"trans-duration":_vm.transDuration,"loading-process":_vm.loadingProcess}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }